<div class="map-privacy-banner">
  <div class="map-privacy-banner__content">
    <div class="map-privacy-banner__icon">
      <svg width="44" height="44" viewBox="0 0 44 44" fill="none">
        <path
          opacity="0.3"
          d="M9.16797 33.5683L14.668 31.4417V9.99167L9.16797 11.8433V33.5683ZM29.3346 34.0083L34.8346 32.1567V10.4317L29.3346 12.5767V34.0083Z"
          fill="white"
        />
        <path
          d="M37.5833 5.5L37.29 5.555L27.5 9.35L16.5 5.5L6.16 8.98333C5.775 9.11167 5.5 9.44167 5.5 9.86333V37.5833C5.5 38.0967 5.90333 38.5 6.41667 38.5L6.71 38.445L16.5 34.65L27.5 38.5L37.84 35.0167C38.225 34.8883 38.5 34.5583 38.5 34.1367V6.41667C38.5 5.90333 38.0967 5.5 37.5833 5.5ZM14.6667 31.4417L9.16667 33.5683V11.8433L14.6667 9.99167V31.4417ZM25.6667 33.9717L18.3333 31.405V10.0283L25.6667 12.595V33.9717ZM34.8333 32.1567L29.3333 34.0083V12.5767L34.8333 10.45V32.1567Z"
          fill="white"
        />
      </svg>
    </div>

    <div class="map-privacy-banner__text">
      {{ 'mapPrivacy.text' | i18n }}
    </div>
  </div>

  <div class="map-privacy-banner__button">
    <button class="button" (click)="customizeSettings($event)">
      <span class="button__label">
        {{ 'mapPrivacy.button' | i18n }}
      </span>
    </button>
  </div>
</div>
